import React, { useState, useEffect } from "react";
import ListGroup from "react-bootstrap/ListGroup";
import "./style.css";
import API from "../../utils/API";
import cogoToast from "@successtar/cogo-toast";

function CreateServiceRequestClient({
  sourceType,
  source,
  sourceName,
  sourceEmail,
  sourcePhone,
  clientID,
  sourceReturn
}) {
  const [formData, setFormData] = useState({
    serviceReqType: "",
    serviceReqName: "",
    serviceReqEmail: "",
    serviceReqBody: "",
    url: "",
    declaration: "",
    showServiceRequestForm: true,
    docName: "",
    document: ""
  });

  useEffect(() => {
    if (sourceType) {
      console.log("Source type is: " + sourceType);
      console.log("Source is: " + source);
      console.log("Source Name: " + sourceName);
      console.log("Source Email: " + sourceEmail);
      console.log("Source Phone: " + sourcePhone);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getBase64 = (file, callBack) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      callBack(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
      return error;
    };
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleServiceReqSubmit = (event) => {
    event.preventDefault();
    console.log("Submitting Service Request....");
    console.log("File; ");
    console.log(formData);
    console.log(formData.declaration);

    const serviceReqData = {
      type: formData.serviceReqType,
      name: sourceName,
      requester: clientID,
      email: sourceEmail,
      phone: sourcePhone,
      message: formData.serviceReqBody,
      client: clientID
    };

    console.log(serviceReqData);

    if (sourceType === "client") {
      API.saveServiceRequestForClient(serviceReqData, source)
        .then((res) => {
          console.log("Saved Service Request");
          cogoToast.success("Service Request Saved!");
          if (formData.document.length > 0) {
            if (formData.docName.length > 0) {
              API.createDocumentForServiceRequest(res.data._id, {
                docName: formData.docName,
                document: formData.document,
                policyid: res.data._id,
                type: "servicerequest"
              })
                .then((_res) => {
                  console.log(_res.data);
                  cogoToast.success("Uploaded Service Request Document!");
                })
                .catch((_err) => console.log(_err));
            } else {
              API.createDocumentForServiceRequest(res.data._id, {
                docName: sourceName + " Service Request",
                document: formData.document,
                policyid: res.data._id,
                type: "servicerequest"
              })
                .then((_res) => {
                  console.log(_res.data);
                  cogoToast.success("Uploaded Service Request Document!");
                })
                .catch((_err) => console.log(_err));
            }
          }
          setFormData((prev) => ({
            ...prev,
            showServiceRequestForm: false
          }));
        })
        .catch((_err) => console.log(_err));
    } else {
      alert("Source type not recognized, please refresh and try again!");
    }
  };

  const fileSelectedHandler = (event) => {
    event.preventDefault();
    console.log(event.target.files);
    setFormData((prev) => ({
      ...prev,
      docName: event.target.files[0].name
    }));

    if (event.target.files[0]) {
      getBase64(event.target.files[0], (res) => {
        console.log(res);
        setFormData((prev) => ({
          ...prev,
          document: res
        }));
      });
    }
  };

  const showServiceRequestForm = () => {
    setFormData((prev) => ({
      ...prev,
      showServiceRequestForm: true
    }));
  };

  return (
    <div className="card" style={{ backgroundColor: "transparent" }}>
      <div
        className="card-header"
        style={{ textAlign: "center", backgroundColor: "rgba(255,255,255,0.8)" }}
      >
        <h2>Service Request Form</h2>
        <p>
          <strong>
            NOTE: Changes in coverage can not be made via this tool, please call us for those
          </strong>
        </p>
      </div>
      <div
        className="card-body"
        style={{ color: "black", textAlign: "center", backgroundColor: "rgba(255,255,255,0.7)" }}
      >
        <div className="row">
          <div className="col-md-10 offset-md-1">
            {formData.showServiceRequestForm ? (
              <ListGroup className="list-group-flush">
                <form>
                  <ListGroup.Item>
                    <label>Category</label>
                    <br />
                    <select
                      style={{ width: "100%" }}
                      value={formData.serviceReqType}
                      onChange={handleInputChange}
                      name="serviceReqType"
                    >
                      <option value=""></option>
                      <option value="add-driver">Add Driver</option>
                      <option value="add-jewelry">Add Jewelry</option>
                      <option value="add-vehicle">Add Vehicle</option>
                      <option value="billing">Billing</option>
                      <option value="claim">Claim Assistance</option>
                      <option value="general">General</option>
                      <option value="new-rates">Get New Insurance Rates</option>
                      <option value="policy-review">Request a Policy Review Meeting</option>
                      <option value="req-mortgage-doc">
                        Proof of Insurance for Mortgage or Auto Lender
                      </option>
                      <option value="req-other">Reason not listed</option>
                      <option value="renewal-quote">Quote for New Insurance</option>
                    </select>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <label>How may we help you?</label>
                    <textarea
                      value={formData.serviceReqBody}
                      onChange={handleInputChange}
                      name="serviceReqBody"
                      className="form-control"
                      rows="5"
                      cols="30"
                    />
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <label>Please upload any related documentation (optional)</label>
                    <input name="fileData" type="file" onChange={fileSelectedHandler} />
                  </ListGroup.Item>
                  <ListGroup.Item style={{ textAlign: "center" }}>
                    <button
                      type="button"
                      style={{
                        color: "white",
                        fontSize: "20px",
                        boxShadow: "0px 0px 1px 1px black",
                        backgroundImage: "linear-gradient(147deg, black 90%, white 0%)",
                        padding: "5px 20px 5px 20px",
                        borderRadius: "5px"
                      }}
                      onClick={(e) => handleServiceReqSubmit(e)}
                    >
                      Submit
                    </button>
                  </ListGroup.Item>
                </form>
              </ListGroup>
            ) : (
              <div className="row">
                <div className="col">
                  <h3>
                    Thank you for submitting your request, would you'd like to enter another one?
                  </h3>
                  <br />
                  <button onClick={() => sourceReturn()}>No thank you.</button>
                  <br />
                  <br />
                  <button onClick={() => showServiceRequestForm()}>Yes please!</button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateServiceRequestClient;
